export default "__VITE_ASSET__d1e4c3b4__"